<template>
  <el-dialog
    custom-class="app-category-editor-dialog"
    width="380px"
    :title="title"
    :visible="visible"
    @close="handleClose"
    append-to-body>
    <div class="app-category-editor">
      <el-form :model="form" :rules="rules" ref="form" label-width="90px" status-icon>
        <el-form-item label="分类名称" prop="name" size="small">
          <el-input type="text" v-model="form.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="上传图片" prop="images" size="small">
          <app-img-uploader :image="form.images | showFirstImage" @success="handleImgUploadSuccess" size="small"></app-img-uploader>
        </el-form-item>
        <div class="app-category-editor__footer">
          <el-button size="mini" @click="handleBtnCancelClick">取消</el-button>
          <el-button type="primary" size="mini" @click="handleBtnOkClick">确认</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import AppImgUploader from '@/components/AppImgUploader'

export default {
  name: 'AppCategoryEditorDialog',
  components: {
    AppImgUploader
  },

  props: {
    title: {
      type: String,
      default: '添加分类'
    },
    visible: {
      type: Boolean,
      default: false
    },
    category: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      form: {
        id: undefined,
        name: '',
        images: []
      },
      rules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'change' },
          { min: 2, max: 10, message: '分类名称：2-10字', trigger: 'change' }
        ],
        images: { type: 'array', required: true, message: '请添加分类图片', trigger: 'manual' }
      }
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    }
  },

  watch: {
    category (newValue, oldValue) {
      this.form.id = newValue.id
      this.form.name = newValue.name
      this.form.images = [ ...newValue.imageList ]
    }
  },

  methods: {
    createCategory (cb) {
      this.$store.dispatch('createCategory', {
        body: {
          category: {
            name: this.form.name,
            imageList: this.form.images
          }
        },
        params: { userId: this.user.id }
      }).then(response => {
        this.$message({
          type: 'success',
          message: '添加分类成功!'
        })
        cb && cb()
      }).catch(() => {
        // No handler
      })
    },

    updateCategory (cb) {
      this.$store.dispatch('updateCategory', {
        body: {
          category: {
            id: this.form.id,
            name: this.form.name,
            imageList: this.form.images
          }
        },
        params: {
          userId: this.user.id,
          categoryId: this.form.id
        }
      }).then(response => {
        this.$message({
          type: 'success',
          message: '更新分类成功!'
        })
        cb && cb()
      }).catch(() => {
        // No handler
      })
    },

    submit (cb) {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.updateCategory(cb)
          } else {
            this.createCategory(cb)
          }
        }
      })
    },

    handleImgUploadSuccess (response) {
      this.form.images = [ response.file_id ]
      this.$refs.form.validateField('images')
    },

    handleBtnOkClick () {
      this.submit(() => {
        this.$emit('ok')
      })
    },

    handleBtnCancelClick () {
      this.handleClose()
    },

    handleClose () {
      this.$refs.form.resetFields()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.app-category-editor-dialog .el-dialog__body {
  padding: 15px 15px 0;
}

.app-category-editor {
  .el-form-item.is-required .el-form-item__label:before {
    font-family: sans-serif;
  }

  &__footer {
    padding: 15px 0;
    border-top: 1px solid $border-color;
    text-align: right;
  }
}
</style>
